import { StateCreator } from 'zustand'

import { LoadingState } from './types'

export const createLoadingSlice: StateCreator<LoadingState, [], [], LoadingState> = (set) => ({
  isLoading: false,

  setIsLoading: (isLoading) => set(() => ({ isLoading })),
})
